import { managePhrases } from './../utils';
import { LogicContext } from '../types';
import Cookies from '../../../ports-frontend/Cookie';

export const fetchRecentPhrases = async (context: LogicContext) => {
  const {
    recentPhrases,
    phrasePendingAdditionToRecentPhrases: phraseToAdd,
  } = context;
  const { loggedIn } = context.user;
  let phrases = recentPhrases;

  if (!loggedIn) {
    return {
      recentPhrases: [],
      updates: [],
    };
  }

  if ((!phrases || !phrases.length) && (await Cookies.has('recentPhrases'))) {
    phrases = JSON.parse(await Cookies.get('recentPhrases'));
  }

  const finalPhrases = phraseToAdd
    ? managePhrases(phrases, phraseToAdd, 5)
    : phrases;

  return {
    recentPhrases: finalPhrases || [],
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchHistory.properties.phrases`,
          value: finalPhrases,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchSuggestions.properties.recentPhrases`,
          value: finalPhrases,
        },
      },
    ],
  };
};
